import styled, { css } from 'styled-components';
import {
  Icon,
  isMobileStyleMixin,
  Link,
  Text,
  TextButton,
} from '@amzn/storm-ui';
import { KeyValueAttribute, LinkAttribute } from '@amzn/storm-ui-page-header';
import { VALUE_STYLE } from '../types';

export enum BarStyleType {
  LABEL,
  CONTENT,
}

export const Value = styled(Text)<{ valueStyle?: VALUE_STYLE }>`
  color: ${({ valueStyle, theme }) =>
    valueStyle === VALUE_STYLE.SUCCESS
      ? theme.color.green[700]
      : valueStyle === VALUE_STYLE.DISABLED
        ? theme.color.gray[600]
        : valueStyle === VALUE_STYLE.WARNING
          ? theme.color.orange[700]
          : valueStyle === VALUE_STYLE.ERROR
            ? theme.color.red[600]
            : theme.color.gray[1000]};
`;

export const StyledLink = styled(Link)<{ disabled?: boolean }>`
  line-height: 1.465;

  && {
    color: ${({ theme }) => theme.color.lightBlue[700]};
  }

  ${(props) =>
    props.disabled &&
    css`
      && {
        color: ${({ theme }) => theme.color.gray[600]};
      }

      cursor: not-allowed;
    `}
`;

export const BarText = styled(Text)<{ styleType: BarStyleType }>`
  ${({ styleType }) =>
    styleType === BarStyleType.CONTENT
      ? css`
          margin-left: 5px;
          ${isMobileStyleMixin(css`
            margin-left: unset;
          `)}
        `
      : styleType === BarStyleType.LABEL
        ? css`
            margin-right: 5px;
            ${isMobileStyleMixin(css`
              margin-right: 4px;
            `)}
          `
        : null}
  white-space: nowrap;
`;

export const ProgressIndicatorWrap = styled.span`
  width: 90px;
  align-self: center;
  ${isMobileStyleMixin(css`
    width: unset;
    flex-grow: 1;
    min-width: 35%;
  `)}
`;

export const APIFailureIcon = styled(Icon)`
  color: ${({ theme }) => theme.color.red[800]};
  margin-left: 5px;
`;

export const KeyText = styled(Text)`
  margin-inline-end: 3px;
`;

export const LabelText = styled(Text)`
  && {
    margin-inline-start: 6px;

    ${isMobileStyleMixin(css`
      margin-inline-start: 14px;
    `)};
  }
`;

export const TextLinkButton = styled(TextButton)`
  display: block;
  font-size: 12px;
  line-height: 18px;
`;

export const TextLinkValue = styled(Text)`
  color: ${({ theme }) => theme.color.lightBlue[700]};

  &:hover {
    text-decoration: underline;
  }
`;

export const TextLinkIcon = styled(Icon)`
  color: ${({ theme }) => theme.color.gray[700]};
  margin-inline-start: 4px;
`;

export const StyledKeyValueAttribute = styled(KeyValueAttribute)`
  & a {
    color: ${({ theme }) => theme.link.color.default};
  }

  & label {
    padding: 0;
  }
`;

export const StyledLinkAttribute = styled(LinkAttribute)`
  && {
    color: ${({ theme }) => theme.link.color.default};
  }
`;
